import { booleanToRadioValue } from "./boolean-to-radio-value";
import { radioValueToYesNoString } from "./radio-value-to-yes-no-string";

export const booleanToYesNoString = (boolean?: boolean | null) => {
  return radioValueToYesNoString(booleanToRadioValue(boolean));
};
